export type ChipColor = 'success' | 'error' | 'warning' | 'info' | 'default';

/**
 * Minimal shape needed to resolve a batch's display status. Both the list row
 * and the detail payload satisfy it structurally.
 */
type BatchStatusSource = {
    status: string;
    invoices: { status: string }[];
    failedInvoices: unknown[];
};

const COMPLETED_INVOICE_STATUSES = ['CREATED', 'SENT', 'EXTERNAL_INVOICE_ERROR'];

export const BATCH_STATUS_COLORS: Record<string, ChipColor> = {
    COMPLETED: 'success',
    FAILED: 'error',
    PARTIAL: 'warning',
    ERROR: 'error',
    PROCESSING: 'info',
};

export const resolveBatchDisplayStatus = (batch: BatchStatusSource): string => {
    // EXTERNAL_INVOICE_ERROR is a delivered invoice whose Fortnox attachment failed (DD-3504): it is
    // neither an error here (the retry advice would re-invoice the customer) nor still processing.
    const hasErrors = batch.failedInvoices.length > 0 || batch.invoices.some((invoice) => invoice.status === 'ERROR');
    if (hasErrors) return 'ERROR';

    const isProcessing = batch.invoices.some((invoice) => invoice.status === 'PROCESSING');
    if (isProcessing) return 'PROCESSING';

    const isCompleted = batch.invoices.every((invoice) => COMPLETED_INVOICE_STATUSES.includes(invoice.status));
    if (isCompleted) return 'COMPLETED';

    if (batch.status === 'PARTIAL') return 'PARTIAL';
    return batch.status;
};
